<div class="page-body">
  <div class="row">
    <div class="col-sm-12">
      <app-card [cardOptionBtnValue]="'global.add_btn_text'|translate " [title]="'global.archive'|translate">
        <app-grid [grid]="grid" ></app-grid>
        <button class="btn btn-primary ripple light pull-right my-3" (click)="goToOverview()"
                type="button">{{'admin.solution.overview.button'|translate}}</button>
      </app-card>
    </div>
  </div>
</div>
<app-modal-basic #reAddModal>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'global.soft_readd_title' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="reAddModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'global.soft_readd_body' | translate}}: <span [innerHTML]="solutionName"></span>?</p>
  </div>
  <div class="app-modal-footer">
    <button type="button" class="btn btn-simple ripple me-4" (click)="reAddModal.hide()">{{'global.cancel'|translate}}</button>
    <button type="button" class="btn btn-primary ripple light" (click)="reAddSolution()">{{'global.readd'|translate}}</button>
  </div>
</app-modal-basic>
